import * as React from "react";
import { cn } from "@/lib/cn";

export interface LGoStatProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
  icon?: React.ReactNode;
  delta?: { value: number; label?: string };
  emphasis?: "normal" | "hero";
}

function deltaTone(n: number) {
  if (n > 0) return "text-success";
  if (n < 0) return "text-destructive";
  return "text-muted-foreground";
}

export const LGoStat = React.forwardRef<HTMLDivElement, LGoStatProps>(
  ({ label, value, hint, icon, delta, emphasis = "normal", className, ...props }, ref) => {
    const hero = emphasis === "hero";
    return (
      <div ref={ref} className={cn("flex flex-col gap-1", className)} {...props}>
        <div className="flex items-start justify-between gap-3">
          <span className="text-xs font-medium uppercase tracking-widest text-muted-foreground">
            {label}
          </span>
          {icon && <span className="text-muted-foreground">{icon}</span>}
        </div>
        <div className="flex items-baseline gap-2">
          <span
            className={cn(
              "font-display font-semibold tracking-tight leading-none text-foreground",
              hero ? "text-5xl" : "text-3xl",
            )}
          >
            {value}
          </span>
          {delta && (
            <span className={cn("text-xs font-medium", deltaTone(delta.value))}>
              {delta.value > 0 ? "+" : ""}
              {delta.value}
              {delta.label ? ` ${delta.label}` : ""}
            </span>
          )}
        </div>
        {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
      </div>
    );
  },
);
LGoStat.displayName = "LGoStat";
